import { inferRouteObject } from 'react-router-typed-object';

import { PrivateRoute, Roles, or } from '@/js/libs/use-auth';

import { forecastRouterSearchParamsSchema } from 'src/scenes/Orders/containers/Forecast/constants.ts';
import { programmaticDealsRouterSearchParamsSchema } from 'src/scenes/Orders/containers/ProgrammaticDeals/schema.ts';
import Orders from 'src/scenes/Orders/index.ts';
import Status from 'src/scenes/Status/index.ts';

export const orders2RouteObject = inferRouteObject({
  path: 'orders',
  element: (
    <PrivateRoute
      roles={or(Roles.ADMIN, Roles.SELF_BOOKING, Roles.BOOK_CAMPAIGNS, Roles.POSTNETZ_BRANCH_USER, Roles.READ_ONLY_POSTNETZ_BRANCH_USER)}
      noAccessComponent={Status.NotFound}
    />
  ),
  children: [
    {
      Component: Orders.Helmet,
      children: [
        {
          element: <PrivateRoute roles={Roles.PROGRAMMATIC_DEALS} noAccessComponent={Status.NotFound} />,
          children: [
            {
              path: 'programmatic-deals',
              Component: Orders.ProgrammaticDeals,
              searchParams: programmaticDealsRouterSearchParamsSchema.parse,
            },
          ],
        },
        {
          Component: Orders.PositionHistory.Providers,
          children: [
            {
              path: 'campaign/:campaignId/position-history/:positionId?',
              Component: Orders.PositionHistory.Component,
            },
          ],
        },
        {
          element: <PrivateRoute roles={Roles.MANAGE_DIGITAL_PRODUCTS} noAccessComponent={Status.NotFound} />,
          children: [
            {
              path: 'forecast',
              Component: Orders.Forecast,
              searchParams: forecastRouterSearchParamsSchema.parse,
            },
          ],
        },
        {
          path: 'booking',
          Component: Orders.Booking,
        },
      ],
    },
  ],
});
